import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { ButtonLinkSideMenu } from '../common/styled'

const MenuItem = (props) => {
  const [hover, setHover] = useState(false)
  const [children, setChildren] = useState([])
  const [expandSubMenu, setExpandSubMenu] = useState(false)

  useEffect(() => {
    if (props.children && props.children.length > 0) {
      setChildren(props.children.filter((i) => i.render))
    }
  }, [props.children])

  const hoverOn = () => setHover(true)

  const hoverOut = () => setHover(false)

  const isSubMenuActive = (path) => path === props.pathname

  const handleNavigationClick = (path) => {
    if (children.length) {
      setExpandSubMenu(!expandSubMenu)
    } else {
      props.handleNavClick(path)
    }
  }
  const { iconClass, isActive, path, title } = props
  let color = hover ? '#fff' : '#a7b1c2'
  if (isActive) {
    color = '#fff'
  }
  return (
    <li className={`${isActive ? 'active' : ''}`}>
      <ButtonLinkSideMenu
        style={{ color: color }}
        onMouseEnterFunc={hoverOn}
        onMouseLeaveFunc={hoverOut}
        onClickFunc={() => handleNavigationClick(path)}
      >
        <i className={iconClass} style={{ marginRight: '3px', marginLeft: '0' }} />{' '}
        <span className='nav-label'>{title}</span>
      </ButtonLinkSideMenu>
      {children.length > 0 && (
        <ul
          className={`nav nav-second-level ${expandSubMenu ? 'collapse in' : 'collapsing'}`}
          style={{ backgroundColor: isActive ? '#293846' : '#2F4050' }}
        >
          {children.map((item, i) => (
            <li key={i} className={isSubMenuActive(item.path) ? 'active' : ''}>
              <Link to={item.path}>- {item.title}</Link>
            </li>
          ))}
        </ul>
      )}
    </li>
  )
}

const mapStateToProps = (state, ownProps) => ({
  pathname: ownProps.location.pathname,
})

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MenuItem))
